import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Typography,
  Box,
  Avatar,
  Alert,
} from '@mui/material';
import { Image } from '@mui/icons-material';

const EditProductDialog = ({ open, onClose, onSave, editForm, setEditForm, product }) => {
  const [imagePreview, setImagePreview] = useState(null);



  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64 = e.target.result.split(',')[1]; // Usuń prefix data:image/...;base64,
        // Konwertuj base64 na byte array
        const byteArray = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
        
        setEditForm({
          ...editForm, 
          image: {
            data: Array.from(byteArray),
            contentType: file.type
          }
        });
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Inicjalizuj podgląd obrazu gdy produkt ma obraz
  React.useEffect(() => {
    if (product?.imageBase64) {
      setImagePreview(`data:image/jpeg;base64,${product.imageBase64}`);
    } else {
      setImagePreview(null);
    }
  }, [product]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Edytuj produkt</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ pt: 2 }}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Nazwa produktu"
              value={editForm.name}
              onChange={(e) => setEditForm({...editForm, name: e.target.value})}
              sx={{ mb: 2 }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Purchase Price"
              value={editForm.purchasePrice}
              onChange={(e) => setEditForm({...editForm, purchasePrice: e.target.value})}
              sx={{ mb: 2 }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="External ID"
              value={editForm.externalId}
              onChange={(e) => setEditForm({...editForm, externalId: e.target.value})}
              sx={{ mb: 2 }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Ilość"
              type="number"
              value={editForm.quantity}
              onChange={(e) => setEditForm({...editForm, quantity: parseInt(e.target.value) || 0})}
              sx={{ mb: 2 }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Zdjęcie produktu
            </Typography>
            <Box sx={{ mb: 2 }}>
              {imagePreview && (
                <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    src={imagePreview}
                    sx={{ mr: 2, width: 80, height: 80, borderRadius: 2 }}
                  />
                  <Typography variant="body2" color="text.secondary">
                    Aktualne zdjęcie produktu
                  </Typography>
                </Box>
              )}
              <Button
                variant="outlined"
                component="label"
                startIcon={<Image />}
                sx={{ mb: 2 }}
              >
                {imagePreview ? 'Zmień zdjęcie' : 'Dodaj zdjęcie'}
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleImageUpload}
                />
              </Button>
              {editForm.image && (
                <Alert severity="info" sx={{ mt: 1 }}>
                  Nowe zdjęcie zostało wybrane i zostanie zapisane po kliknięciu "Zapisz zmiany"
                </Alert>
              )}
            </Box>
          </Grid>

        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Anuluj
        </Button>
        <Button variant="contained" onClick={onSave}>
          Zapisz zmiany
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditProductDialog; 